import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import * as api from './api'

export const get = createAsyncThunk('companyInfo/GET', async (payload, thunkAPI) => {
  const result = await api.get()

  if (result.error) return thunkAPI.rejectWithValue(result.error)
  return result.data
})

export const update = createAsyncThunk('companyInfo/UPDATE', async (payload, thunkAPI) => {
  const { data, error } = await api.update(payload)
  if (error) return thunkAPI.rejectWithValue(error)
  return data
})

export const slice = createSlice({
  name: 'companyInfo',
  initialState: {
    model: null,
    isModelLoading: false,
    isModelRefreshing: false,
    error: null,
    isUpdated: false,
  },
  reducers: {
    clearError: state => {
      state.error = null
    },
    clearMessages: state => {
      state.isUpdated = false
    },
  },
  extraReducers: builder => [
    builder
      .addCase(get.pending, state => {
        state.isModelRefreshing = true
        state.error = null
      })
      .addCase(get.fulfilled, (state, action) => {
        state.isModelRefreshing = false
        state.model = action.payload
      })
      .addCase(get.rejected, (state, action) => {
        state.isModelRefreshing = false
        state.error = action.payload
      })
      .addCase(update.pending, state => {
        state.isModelLoading = true
        state.error = null
      })
      .addCase(update.fulfilled, (state, action) => {
        state.isModelLoading = false
        state.model = action.payload
        state.isUpdated = true
      })
      .addCase(update.rejected, (state, action) => {
        state.isModelLoading = false
        state.error = action.payload
      }),
  ],
})

export const { clearError, clearMessages } = slice.actions

export const modelSelector = state => state.companyInfo.model
export const isModelLoadingSelector = state => state.companyInfo.isModelLoading
export const isModelRefreshingSelector = state => state.companyInfo.isModelRefreshing
export const errorSelector = state => state.companyInfo.error
export const isUpdatedSelector = state => state.companyInfo.isUpdated

export const reducer = slice.reducer
